import services from "@/config/services";
import axios from "axios";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class AutoLetturaService {
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_pratiche.url}`;
    this.baseUrlApi = `${services.ask_api.url}`;
    this.filemanager = new FileManager();
    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      // this.eventBus.emit('data-loading');
      return req;
    });
  }

  async getListAutoLettura(params) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListAutoLettura`;
      const response = await axios.get(url, {
        params: {
          data_riferimento: params.data_riferimento,
          fornitura_code: params.fornitura_code
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }


  async changeUsedStatus(recordId) {
    try {
      console.log('Tentativo di aggiornamento record con ID:', recordId);
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/changeUsedStatus`;
      const response = await axios.post(url, {
        record_id: recordId
      });
      return response.data.message;
    } catch (error) {
      console.error("Errore durante il cambio dello stato del record:", error);
      throw error;
    }
  }

  async addNewLettura(obj){
    try {
      let url;
      let requestData;

      if (obj.cod_pdr) {
        url = `${this.baseUrlApi}/management/pdrs/lettura/create`;
        requestData = {
          obj: {
            fornitura_code: obj.cod_pdr,
            mq: obj.consumo,
            coeff: obj.coeff,
            user: obj.user,
            user_id: obj.user_id,
            eaf1: 0,
            eaf2: 0,
            eaf3: 0,
            erf1: 0,
            erf2: 0, 
            erf3: 0,
            pf1: 0,
            pf2: 0,
            pf3: 0
          },
          data: obj.date_autolettura
        };
      } else {
        url = `${this.baseUrlApi}/management/pods/lettura/create`;
        requestData = {
          obj: {
            fornitura_code: obj.cod_pod,
            eaf1: obj.eaf1,
            eaf2: obj.eaf2,
            eaf3: obj.eaf3,
            erf1: obj.erf1,
            erf2: obj.erf2,
            erf3: obj.erf3,
            pf1: obj.pf1,
            pf2: obj.pf2,
            pf3: obj.pf3,
            user: obj.user,
            user_id: obj.user_id,
            mq: 0,
            date_autolettura: obj.date_autolettura,
            data_riferimento: obj.data_riferimento       
           }
        };
      }

      console.log('Dati inviati al backend:', requestData);
      const response = await axios.post(url, requestData);

      return {
        success: response.data !== false,
        data: response.data
      };
    } catch (error) {
      console.error("Errore durante la creazione della lettura:", error);
      return {
        success: false,
        message: error.response?.data?.message || error.message
      };
    }
  }

  async addNewLetturaGas(obj){
    try {
      const url = `${this.baseUrlApi}/management/pdrs/lettura/create`;
      const response = await axios.post(url, { 
        obj: {
          fornitura_code: obj.cod_pod,
          eaf1: obj.eaf1,
          eaf2: obj.eaf2,
          eaf3: obj.eaf3,
          erf1: obj.erf1,
          erf2: obj.erf2,
          erf3: obj.erf3,
          pf1: obj.pf1,
          pf2: obj.pf2,
          pf3: obj.pf3,
          user: obj.user,
          date_autolettura: obj.date_autolettura,
          data_riferimento: obj.data_riferimento
        }
      });
      
      return {
        success: response.data,
        data: response.data
      };
    } catch (error) {
      console.error("Errore durante la creazione della lettura:", error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  async getLetture(podId){
    let items = []
    let totalItems = 0

    const url = `${this.apiBaseUrl}/pods/${podId}/letture`
    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }
  
  async getInsertAutoLettura(params) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getInsertAutoLettura`;
      const response = await axios.get(url, {
        params: {
          data_riferimento: params.data_riferimento
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero delle autoletture:", error);
      throw error;
    }
  }

  async confirmedAutoLettura(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/confirmedAutoLettura`;
      const response = await axios.post(url, {
        id_autolettura: data.id_autolettura,
        cod_pod: data.cod_pod,
        cod_pdr: data.cod_pdr
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante la conferma dell'autolettura:", error);
      throw error;
    }
  }

  async verificaLettura(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/verificaLettura`;
      const response = await axios.post(url, {
        id_autolettura: data.id_autolettura,
        current_id: data.current_id,
        cod_pod: data.cod_pod,
        cod_pdr: data.cod_pdr
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante la verifica dell'autolettura:", error);
      throw error;
    }
  }

  // async updateAutoLettura(data) {
  //   try {
  //     const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updateAutoLettura`;
  //     const response = await axios.post(url, {
  //       id_autolettura: data.id_autolettura,
  //       cod_pod: data.cod_pod,
  //       cod_pdr: data.cod_pdr,
  //       a1: data.a1,
  //       a2: data.a2,
  //       a3: data.a3,
  //       r1: data.r1,
  //       r2: data.r2,
  //       r3: data.r3,
  //       p1: data.p1,
  //       p2: data.p2,
  //       p3: data.p3,
  //       mq: data.mq,
  //       date_autolettura: data.date_autolettura,
  //       user: data.user
  //     });
  //     return response.data;
  //   } catch (error) {
  //     console.error("Errore durante l'aggiornamento dell'autolettura:", error);
  //     throw error;
  //   }
  // }

  async uploadDocumento(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadDocumentiAutoletture`;
      const formData = new FormData();
      formData.append('id_autolettura', data.id_autolettura);
      formData.append('cod_pod', data.cod_pod || '');
      formData.append('cod_pdr', data.cod_pdr || '');
      formData.append('documento', data.file);

      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'upload del documento:", error);
      throw error;
    }
  }

  async downloadDocumento(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadDocumentiAutoletture`;
      const response = await axios.post(url, {
        id_autolettura: data.id_autolettura,
        cod_pod: data.cod_pod || '',
        cod_pdr: data.cod_pdr || '',
        filename: data.filename || ''
      }, {
        responseType: 'blob'
      });

      this.filemanager.download(response);
    } catch (error) {
      console.error("Errore durante il download del documento:", error);
      throw error;
    }
  }

  async getDocumentiAutolettura(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getDocumentiAutolettura`;
      const response = await axios.get(url, {
        params: {
          id_autolettura: data.id_autolettura,
          cod_pod: data.cod_pod || '',
          cod_pdr: data.cod_pdr || ''
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei documenti:", error);
      throw error;
    }
  }

  async deleteDocumento(data) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/deleteDocumentoAutolettura`;
      const response = await axios.post(url, {
        id_autolettura: data.id_autolettura,
        cod_pod: data.cod_pod || '',
        cod_pdr: data.cod_pdr || '',
        filename: data.filename
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'eliminazione del documento:", error);
      throw error;
    }
  }

  async fetchUltimaLettura(params) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/fetchUltimaLettura`;
      const response = await axios.get(url, {
        params: {
          data_riferimento: params.data_riferimento,
          id: params.id,
          type: params.type
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dell'ultima lettura:", error);
      throw error;
    }
  }

  async deleteAutoletturaInDistribuzione(recordId) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/deleteAutoletturaInDistribuzione`;
      const response = await axios.post(url, {
        record_id: recordId
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'eliminazione dell'autolettura in distribuzione:", error);
      throw error;
    }
  }

  async getStoricoAutolettura(id_autolettura) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getStoricoAutolettura`;
    const response = await axios.get(url, {
      params: {
        id: id_autolettura,
        id_autolettura,
      },
    });
    return response.data;
  }
}
